<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-card v-if="!overlay" flat class="py-3 px-3">
            <v-card-text class="pt-0">
              <v-row justify="center" align="center">
                <v-col cols="6">
                  <h2 class="compeatfont">Cancelled Subscriptions</h2>
                </v-col>
                <v-col cols="6"> </v-col>
              </v-row>
            </v-card-text>

            <v-card-title class="pt-0">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search Clients"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
            </v-card-title>
            <!-- {{ activeAcencies }} -->
            <v-data-table
              :headers="headers"
              :items="cancelledSubscriptions"
              :search="search"
              :items-per-page="10"
              :loading="overlay"
              loading-text="Loading... Please wait"
            >
              <template v-slot:[`item.package`]="{ item }">
                {{ item.package.currentPackage }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  @click="viewCancelledSubscription(item)"
                  icon
                  color="primary"
                  ><v-icon>mdi-eye</v-icon></v-btn
                >
              </template>
            </v-data-table>
          </v-card>
          <v-skeleton-loader
            v-else
            height="372px"
            class="mx-auto"
            type="table-heading, table-thead, table-tbody, table-tfoot"
          >
          </v-skeleton-loader>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import generalAlert from "@/components/alerts/generalAlert.vue";
const moment = require("moment-timezone");

import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);
import { collection, getDocs, getFirestore } from "firebase/firestore";
export default {
  components: {
    generalAlert,
  },
  data: () => ({
    //Skeleton loading
    overlay: false,
    //Table Data and varibles
    cancelledSubscriptions: [],
    //For general alert on adding new user
    successResponse: "",
    alertType: "",
    alert: false,
    //Search field and data for table
    search: "",
    headers: [
      { text: "Client", value: "name", sortable: false, align: "center" },
      {
        text: "Company",
        sortable: false,
        value: "package.primaryPage.name",
        align: "center",
      },
      { text: "Package", sortable: false, value: "package", align: "center" },
      {
        text: "Date Created",
        value: "dateCancelled",
        sortable: false,
        align: "center",
      },
      { text: "Status", value: "isActive", sortable: false, align: "center" },
      { text: "Action", value: "action", sortable: false, align: "center" },
    ],
  }),
  created() {
    this.getAllCancelledSubscriptions();
  },
  methods: {
    //Gets all users and filters it out on userType
    async getAllCancelledSubscriptions() {
      this.overlay = true;
      this.cancelledSubscriptions = [];
      try {
        const querySnapshot = await getDocs(
          collection(db, "cancelledsubscriptions")
        );
        querySnapshot.forEach((doc) => {
          let subscription = doc.data();
          let createdMilliseconds = subscription.dateCancelled;
          let formatCreatedDate =
            moment(createdMilliseconds).format("YYYY-MM-DD h:mm a");
          subscription.dateCancelled = formatCreatedDate;

          if (
            (subscription.agencyId === this.$store.state.agency.agencyId &&
              this.$store.state.user.userType == "AA") ||
            (subscription.agencyId === this.$store.state.agency.agencyId &&
              this.$store.state.user.userType == "SMM")
          ) {
            this.cancelledSubscriptions.push(subscription);
          } else if (this.$store.state.user.userType == "SA") {
            this.cancelledSubscriptions.push(subscription);
          } else if (
            subscription.agencyId === this.$store.state.agency.agencyId &&
            subscription.resellerUid === this.$store.state.user.resellerUid &&
            this.$store.state.user.userType == "RS"
          ) {
            this.cancelledSubscriptions.push(subscription);
          }
        });

        // Sort the array by date
        this.cancelledSubscriptions.sort((a, b) => {
          return new Date(b.dateCancelled) - new Date(a.dateCancelled);
        });

        this.overlay = false;
      } catch (error) {
        console.log(error);
      }
    },
    //Alert functions to display response from adding new user
    successAlert(message, typeOfAlert) {
      this.successResponse = message;
      this.alertType = typeOfAlert;
      this.alert = true;

      setTimeout(() => {
        this.getAllDemoSubscriptions();
        this.alert = false;
      }, 3000);
    },
    //View the Cancelled subscription
    viewCancelledSubscription(item) {
      this.$router.push({
        name: "singleCancelledSubscription",
        params: {
          id: item.agencyId,
          uid: item.uid,
        },
      });
    },
  },
};
</script>
